// extracted by mini-css-extract-plugin
module.exports = {"updateButtons":"recRendering_updateButtons__2xRMG"};